
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesReceiptDetailsDialog extends Serenity.EntityDialog<POSSalesReceiptDetailsRow, any> {
        protected getFormKey() { return POSSalesReceiptDetailsForm.formKey; }
        protected getIdProperty() { return POSSalesReceiptDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return POSSalesReceiptDetailsRow.localTextPrefix; }
        protected getService() { return POSSalesReceiptDetailsService.baseUrl; }
        protected getDeletePermission() { return POSSalesReceiptDetailsRow.deletePermission; }
        protected getInsertPermission() { return POSSalesReceiptDetailsRow.insertPermission; }
        protected getUpdatePermission() { return POSSalesReceiptDetailsRow.updatePermission; }

        protected form = new POSSalesReceiptDetailsForm(this.idPrefix);

    }
}